module.exports = __webpack_public_path__ + "static/media/pineapple.73d1f9d5.JPG";